var map = {
	"./1/questiongroups/results.json": 2537
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2536;


//////////////////
// WEBPACK FOOTER
// ./src/services/API/fixtures/institutions/assessments ^\.\/.*\/questiongroups\/results\.json$
// module id = 2536
// module chunks = 0